<template>
  <div>
    <h3>{{ tags.GET_STARTED_HEADING }}</h3>
    <p class="eligibility_label">
      Check the eligibility of your company in 60 seconds
    </p>
    <Input
      @enter="next"
      :inputField="inputs.requestedAmount"
      :inputName="tags.BASIC_INFO_QUESTION_CASH"
      inputType="currency"
      :range="[5000, 500000]"
      :icons="{ left: 'fa-dollar-sign' }"
    />
    <!-- <hr> -->
    <Input
      @enter="next"
      :inputField="inputs.monthly_sales"
      inputName="What is your Average Monthly Sales?"
      inputType="currency"
      :icons="{ left: 'fa-dollar-sign' }"
    />
    <label class="label estimate_yearly_sales"
      >Estimated Yearly Sales: {{ yearly_sales }}</label
    >
    <Input
      @enter="next"
      :inputField="inputs.name"
      :inputName="tags.BASIC_INFO_LEGAL_NAME"
      inputType="name"
    />
    <Dropdown
      :inputField="inputs.classification"
      :options="classificationOptions"
      :inputName="tags.BASIC_INFO_CLASSIFICATION"
    />
    <AddressInput
      :inputField="inputs.address"
      :inputName="tags.BASIC_INFO_ADDRESS"
      inputType="string"
      @selectedAddress="updateAddress"
    />
    <!-- <i
      v-show="selected_address == true"
      class="address_selected fas fa-check"
    ></i
    >&nbsp;
    <i
      v-show="selected_address == false"
      class="address_selected fas fa-solid fa-exclamation"
    ></i
    >&nbsp; <label class="label full_address">{{ full_address }}</label
    >&nbsp;
    <a class="toggle_address" href="#" @click="toggleAddressFields">
      or manually type address</a
    > -->
    <Input
      @enter="next"
      :inputField="inputs.city"
      :inputName="tags.BASIC_INFO_CITY"
      inputType="string"
      ref="city"
      autocomplete="address-level2"
    />
    <Input
      @enter="next"
      :inputField="inputs.state"
      :inputName="tags.BASIC_INFO_STATE"
      inputType="state"
      ref="state"
      autocomplete="address-level1"
    />
    <Input
      @enter="next"
      :inputField="inputs.zip"
      :inputName="tags.BASIC_INFO_ZIP_CODE"
      inputType="zip"
      ref="zip"
      autocomplete="postal-code"
    />
    <Input
      @enter="next"
      :inputField="inputs.email"
      inputName="Business Email Address"
      inputType="email"
      :icons="{ right: 'fa-envelope' }"
    />
    <Input
      @enter="next"
      :inputField="inputs.phone"
      inputName="Cell Phone"
      inputType="phone"
      :icons="{ right: 'fa-mobile-alt' }"
    />
    <Checkbox
      :inputField="inputs.smsOptIn"
      inputName="SMS Optin"
      inputType=""
    >
      By checking this box, you agree to receive recurring automated promotional and personalized marketing text messages (e.g. app reminders) from Cardiff at the cell number used when signing up. Consent is not a condition of any purchase. 
      Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. 
      View <a href="https://attnl.tv/t/3Rk" target="_blank">Terms</a> & <a href="https://attnl.tv/p/3Rk" target="_blank">Privacy</a>.
    </Checkbox>
    <Checkbox
      :inputField="inputs.smsConsent"
      :inputName="tags.BASIC_INFO_SMS_CONSENT"
      inputType="required"
    >
      {{ tags.BASIC_INFO_AGREEMENT_TO }}
      <a href="/application-agreement/" target="_blank">
        {{ tags.BASIC_INFO_APPLICATION_AGREEMENT }}
      </a>
      {{ tags.BASIC_INFO_AND }}
      <a href="/e-sign-consent/" target="_blank">
        {{ tags.BASIC_INFO_E_SIGNATURE_AGREEMENT }} </a
      >.
    </Checkbox>
    <div class="buttons is-right" @click="handleBlur">
      <!-- <a class="button is-link is-inverted padded-button next-button">Skip</a> -->
      <a class="button is-link padded-button next-button" @click="next">{{
        tags.BASIC_INFO_CONTINUE_TEXT
      }}</a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CONSTANTS from "@/tools/translations.js";
import Input from "@/components/shared/Input";
import Dropdown from "@/components/shared/Dropdown";
import Checkbox from "@/components/shared/Checkbox";
import AddressInput from "@/components/shared/AddressInput";
import ApplyPage from "@/components/shared/ApplyPage";
import $ from "jquery";

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "GetStarted",
  components: {
    Input,
    Dropdown,
    AddressInput,
    Checkbox,
  },
  mixins: [ApplyPage],
  props: {
    amt: String,
    lang: String,
  },
  created: function () {
    this.language = "en";
    if (this.$route.params.language) {
      this.language = this.$route.params.language;
    }
    var tags = [];
    var language = this.language;
    $.each(CONSTANTS, function (key, value) {
      var translation = value[language];
      tags[key] = value[language];
    });

    this.tags = tags;
    //console.log(tags);
    // this.GET_STARTED_HEADING = CONSTANTS.GET_STARTED_HEADING[Vue.prototype.$language]
  },
  data() {
    return {
      obj: "business",
      inputs: {
        name: Input.model(),
        address: AddressInput.model(),
        city: Input.model(),
        state: Input.model(),
        zip: Input.model(),
        classification: Input.model(),
        requestedAmount: Input.model(this.amt),
        smsConsent: Input.model(),
        utm_device_type: this.getDeviceType(),
        utm_browser: this.getBrowserName(),
        utm_OS: this.getOperatingSystem(),
        monthly_sales: Input.model(),
        gclid: this.getGCLID(),
        fbclid: this.getFBCLID(),
        fbp: this.getFBP(),
        ttclid: this.getTTCLID(),
        email: Input.model(),
        phone: Input.model(),
        smsOptIn: Input.model(),
      },
      classificationOptions: [
        "Sole Proprietorship",
        "Partnership",
        "LLC",
        "C Corporation",
        "S Corporation",
      ],

      tags: [],

      show_address_fields: true,
      selected_address: false,
      full_address: "Please type and select your business address",
      yearly_sales: "$ 0",
    };
  },
  methods: {
    handleBlur: function () {
      console.log("focus out");
    },
    // toggleAddressFields: function () {
    //   this.show_address_fields = !this.show_address_fields;
    // },
    getOperatingSystem: function () {
      let userAgent = navigator.userAgent || window.navigator.userAgent;
      let macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
      let windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
      let iosPlatforms = ["iPhone", "iPad", "iPod"];

      let os = null;

      macosPlatforms.forEach(function (platform, index) {
        if (userAgent.search(platform) !== -1) {
          os = platform;
        }
      });

      iosPlatforms.forEach(function (platform, index) {
        if (userAgent.search(platform) !== -1) {
          os = platform;
        }
      });

      windowsPlatforms.forEach(function (platform, index) {
        if (userAgent.search(platform) !== -1) {
          os = platform;
        }
      });
      if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(userAgent)) {
        os = "Linux";
      } else if (!os) {
        os = "Other";
      }
      return os;
    },
    getDeviceType: () => {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    },
    getBrowserName: function () {
      let userAgent = navigator.userAgent;
      let browserName;

      if (userAgent.match(/chrome|chromium|crios/i)) {
        browserName = "Chrome";
      } else if (userAgent.match(/firefox|fxios/i)) {
        browserName = "Firefox";
      } else if (userAgent.match(/safari/i)) {
        browserName = "Safari";
      } else if (userAgent.match(/opr\//i)) {
        browserName = "Opera";
      } else if (userAgent.match(/edg/i)) {
        browserName = "Edge";
      } else {
        browserName = "Unknown browser";
      }

      return browserName;
    },
    getGCLID() {
      // console.log(getWithExpiry("gclid"));
      let gclid = getWithExpiry("gclid");
      if (!gclid) return "";
      return gclid;
    },
    getFBCLID() {
      console.log(getWithExpiry("fbclid"));
      let fbclid = getWithExpiry("fbclid");
      if (!fbclid) return "";
      return fbclid;
    },
    getTTCLID() {
      console.log(getWithExpiry("ttclid"));
      let ttclid = getWithExpiry("ttclid");
      if (!ttclid) return "";
      return ttclid;
    },
    getFBP() {
      console.log(getWithExpiry("_fbp"));
      let _fbp = getWithExpiry("_fbp");
      if (!_fbp) return "";
      return _fbp;
    },
    updateAddress: function (data) {
      // console.log(data);
      this.inputs.city.value = data.city;
      this.inputs.state.value = data.state;
      this.inputs.zip.value = data.zip;
      if (
        data.city &&
        data.city !== "" &&
        data.state &&
        data.state !== "" &&
        data.state &&
        data.state !== ""
      ) {
        // this.show_address_fields = false;
        this.selected_address = true;
        this.full_address =
          data.street_number +
          " " +
          data.street +
          ", " +
          data.city +
          ", " +
          data.state +
          ", " +
          data.zip;
      }
    },
  },
  mounted: function () {
    this.show_address_fields = false;
    //@todo pass this validation inside the component
    let self = this;
    $("#map").focusout(function () {
      // console.log("selected address", self.selected_address);
      if (self.selected_address === false) {
        self.show_address_fields = true;
      }
    });
  },
  watch: {
    inputs: {
      deep: true,
      handler(newValue, oldvalue) {
        // console.log("new value: ");
        // console.log(newValue.refer.value);

        let monthly_sales = Number(
          newValue.monthly_sales.value.replace(/[^0-9\.-]+/g, "")
        );
        if (monthly_sales !== "") {
          let year_sales = monthly_sales * 12;
          let yearly_sales_string = year_sales
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.yearly_sales = "$ " + yearly_sales_string;
        }
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.full_address {
  color: gray;
  display: inline-block;
  margin-bottom: 10px;
}
@media (max-width: 80em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 10px;
    display: inline-block;
  }
}
@media (max-width: 47.999em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 10px;
    display: inline-block;
  }
}
.address_selected {
  color: green;
}
</style>
<style scoped>
.estimate_yearly_sales {
  color: gray;
  display: inline-block;
}
.yearly_sales_amount {
  color: green;
  display: inline-block;
}
</style>